import styled from 'styled-components';

import { Avatar } from '../../../../../../components';
import { ThemeProp } from '../../../../../../theme/Themes';

export const AvatarsContainer = styled.div`
  display: flex;
  gap: 0.125rem;
  cursor: pointer;
`;

interface AvatarProps {
  $isConnected?: boolean;
  $bordered?: boolean;
}

export const AvatarContainer = styled.div<AvatarProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: ${(props: AvatarProps & ThemeProp) =>
    `2px solid ${props.$isConnected ? props.theme.colors.system.success : props.theme.colors.neutrals.c300}`};
  flex-shrink: 0;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const StyledAvatar = styled(Avatar).attrs(() => ({
  squared: true,
  borderRadius: '50%',
}))<AvatarProps>`
  width: ${(props: AvatarProps) => (props.$bordered ? '1.75rem' : '2rem')};
  height: ${(props: AvatarProps) => (props.$bordered ? '1.75rem' : '2rem')};
  min-width: unset;
  min-height: unset;
  border: ${(props: AvatarProps & ThemeProp) =>
    props.$bordered ? `1px solid ${props.theme.colors.neutrals.c100}` : 'none'};

  .nextui-avatar-text {
    color: ${(props: ThemeProp) => props.theme.colors.main.c600};
    font-size: ${(props: ThemeProp) => props.theme.fontSize.xs} !important;
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium} !important;
    transform: translate(-50%, -50%) scale(1);
  }

  .nextui-avatar-bg,
  .nextui-avatar-img {
    border-radius: 0;
  }
  cursor: pointer;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    width: ${(props: AvatarProps) => (props.$bordered ? '2.25rem' : '2.5rem')};
    height: ${(props: AvatarProps) => (props.$bordered ? '2.25rem' : '2.5rem')};
    .nextui-avatar-text {
      font-size: ${(props: ThemeProp) => props.theme.fontSize.ml} !important;
    }
  }
`;

export const TooltipContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem 0 0.5rem;
`;

export const DetailsTitle = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  line-height: normal;
`;

export const DetailsContentList = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding-bottom: 1rem;
  }
`;

export const DetailsContentListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
  height: 3rem;
  &:not(:last-child) {
    border-bottom: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  }
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    height: 3.5rem;
  }
`;

export const DetailsContentListItemLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
`;

export const UserNameContainer = styled.div`
  display: flex;
  overflow: hidden;
  flex-shrink: 1;
`;

export const UserName = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const DateText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.high};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
`;
